<template>
    <div id="slider-container" v-show="actionType">
        <div :class="CLASS_main">
            <div :id="ID_fill" class="slider-fill" ref="fill">
                <input
                    :id="ID_input"
                    class="slider-hide"
                    type="range"
                    min="0"
                    :max="SLIDER_MAX"
                    ref="input"
                    v-model="value"
                    v-on:input="$emit('input', $event.target.value)"
                />
            </div>
            <div :id="ID_thumb" ref="thumb" class="slider-thumb"></div>
        </div>
    </div>
</template>

<script>
import {LATEventBus} from "../modules/LAT/LAT_main";
import {setSliderGrafics} from "../modules/LAT/setSliderGrafics";
import {settings} from "../config";

export default {
    data: function () {
        return {
            value: null,
        };
    },
    props: ["side", "actionType", "teacher"],
    computed: {
        CLASS_main: function () {
            return "slider-main " + this.side;
        },
        ID_fill: function () {
            return "sliderFill" + this.side;
        },
        ID_input: function () {
            return "sliderInput" + this.side;
        },
        ID_thumb: function () {
            return "sliderThumb" + this.side;
        },
        SLIDER_MAX: function () {
            return this.$LAT.settings._SLIDER_RES;
        },
        SLIDER_MIN: function () {
            return this.$LAT.settings._FOV_MIN;
        },
        objectName: function () {
            return "slider" + this.side;
        },
        stepId() {
            return this.teacher ? this.teacher.stepIdx : null
        }
    },
    watch: {
        value() {
            this.setGraphics();
            LATEventBus.$emit('slider-change', {actionType: this.actionType, value: this.value})
        }
    },
    methods: {
        setGraphics() {
            setSliderGrafics(
                this.value,
                this.$refs.thumb,
                this.$refs.fill
            );
        },

        onSliderChange(payload) {
            const {actionType, value} = payload;
            if (actionType !== this.actionType || value === this.value) {
                return;
            }
            this.value = value;
        }

    },
    mounted: function () {
        this.setGraphics();
        LATEventBus.$on('slider-change', this.onSliderChange)
        this.value = this.teacher && this.teacher.isLearning ? this.teacher.getCurrentStepZoomValue() : settings['START_SLIDER_' + this.actionType.toUpperCase()];
    },
    beforeDestroy() {
        LATEventBus.$off('slider-change', this.onSliderChange)
    }
};
</script>

<style lang="scss" scoped></style>
